function GetCurrentSearch() {
    const user = localStorage.getItem('currentSearchText');
    const resp = user != null ? JSON.parse(JSON.stringify(user.toString())) : user;
    return resp;
}

function SetCurrentSearch(user:string){
    localStorage.setItem('currentSearchText',user);
}

export default  {
    GetCurrentSearch,
    SetCurrentSearch
};


